/**
 * L'AIDE DU MODULE PROGRAMME DE FORMATION — les textes (des DONNÉES, pas du code d'écran)
 * ======================================================================================
 * Protocole : doc/specs_techniques/aide_contextuelle.md · Plan : doc/modules/programme_formation.md §16.
 * Lot P.1 (2026-10-31) : l'écran Référentiels, refait. Les autres écrans arrivent avec leur lot (P.2 → P.8) ; la
 * rédaction complète (processus, toutes les tâches) est le lot P.9.
 *
 * ⚠️ Règle 9 du protocole (SUIVI_DEV) : un écran du Programme qui change → sa fiche ici change DANS LE MÊME LOT.
 * Un libellé cité en **gras** doit exister à l'écran (outil frontend/scripts/aide-verifier.js programme).
 * La clé du module est celle des droits : « programme ».
 */

/** Les groupes (niveau 1 de la navigation du module). */
export const GROUPES = {
    referentiels: 'Référentiels'
};

/** Les écrans aidés. La clé est le chemin de navigation ; `court` présente l'écran dans « Les écrans de … ». */
export const ECRANS = [
    { cle: 'referentiels', libelle: 'Référentiels', icone: 'fa-sliders',
      court: 'Les catégories de cours et les modalités du département, et ce que le cadrage national en compte.' }
];

const ECRIRE = 'réservé à qui peut modifier le module';
export const FICHES = {
    referentiels: {
        titre: 'Référentiels du Programme',
        sert: "Les deux listes communes à toutes les formations du département, toutes les années : les catégories de cours (ce qu'est un cours) et les modalités (comment ses heures se font : CM, TD, TP…). Le cadrage national et le volume à réaliser se calculent à partir d'elles.",
        gestes: [
            "**Catégories de cours** : **Ajouter** une catégorie propre au département (code, libellé, couleur) ; le crayon modifie, la corbeille supprime.",
            "**Modalités & groupes** : **Ajouter** une modalité, puis dire si elle **compte dans les heures d'enseignement**.",
            "**Multiplié par** : le type de groupe qui multiplie les heures d'une modalité dans le volume à réaliser (Groupes CM, TD, TP, ou Aucun).",
            "Glisser une ligne de modalité change l'ordre d'affichage.",
            "Chaque changement est enregistré tout de suite : « Enregistré à … » le confirme ; un échec s'affiche en rouge."
        ],
        reserve: `Ajouter, modifier, supprimer, régler « Multiplié par » : ${ECRIRE}. Les autres comptes voient les listes en lecture seule.`,
        savoir: [
            "Les entrées marquées « fournie » (Ressource, SAÉ, Stage ; CM, TD, TP, Projet tutoré) servent au cadrage national : on change leur libellé, leur couleur, leur hTD ou « Multiplié par », jamais leur code, et elles ne se suppriment pas.",
            "Une catégorie ajoutée par le département ne compte pas dans le cadrage national (comme Portfolio, qui peut être supprimé).",
            "Le Projet tutoré compte à part, hors du total des heures d'enseignement, et n'a pas de groupes.",
            "Une catégorie ou une modalité déjà utilisée par des cours ne peut pas être supprimée.",
            "Ces listes ne s'importent plus : les entrées fournies existent d'office dans chaque département."
        ],
        sources: ['programme/ProgReferentiels.js'],
        cites: ['Catégories de cours', 'Ajouter', 'Multiplié par', "compte dans les heures d'enseignement", 'Confirmer la suppression', 'Enregistré à'],
        notions: ['Modalités & groupes']
    }
};

export const ACTEURS = {};
export const PROCESSUS = {};

/** « Je veux… » — les tâches du lot P.1 (la liste complète vient au lot P.9, spec §16). */
export const TACHES = [
    { groupe: 'Référentiels', question: 'Ajouter une modalité propre au département', ecran: 'referentiels',
      gestes: ["Référentiels, onglet **Modalités & groupes** : **Ajouter**.", "Code, libellé, coefficient hTD ; cocher **compte dans les heures d'enseignement** si elle en fait partie.", "Choisir **Multiplié par** sur sa ligne."] },
    { groupe: 'Référentiels', question: 'Régler le nombre de groupes qui multiplie une modalité', ecran: 'referentiels',
      gestes: ["Référentiels, onglet **Modalités & groupes**.", "Sur la ligne de la modalité, choisir **Multiplié par** : Groupes CM, TD, TP, ou Aucun (×1)."] },
    { groupe: 'Référentiels', question: 'Renommer ou recolorer une catégorie de cours', ecran: 'referentiels',
      gestes: ["Référentiels, onglet **Catégories de cours** : le crayon de la ligne.", "Changer le libellé ou la couleur, puis **Enregistrer** (le code d'une catégorie fournie ne change pas)."] }
];

/**
 * « Quoi de neuf » — les changements VISIBLES du module, du plus récent au plus ancien (date AAAA-MM-JJ).
 * ⚠️ Règle 9 : une entrée s'ajoute AU MÊME LOT que le changement.
 */
export const NEUF = [
    { date: '2026-10-31', titre: 'Les Référentiels refaits', ecran: 'referentiels',
      texte: "Catégories et modalités sont communes à toutes les années. Ressource, SAÉ, Stage, CM, TD, TP et Projet tutoré sont fournies d'office (verrouillées) ; chaque modalité dit par quel groupe ses heures se multiplient. Plus de cases Présentiel / Autonomie ni d'import : les calculs du cadrage s'appuient sur ces rôles." }
];

const aide = {
    module: 'programme', titreModule: 'Programme de formation', exemplesRecherche: 'Ex. modalité, catégorie, groupes…',
    GROUPES, ECRANS, FICHES, ACTEURS, PROCESSUS, TACHES, NEUF
};
export default aide;
